<template>
  <div class="dialog" v-show="show" :style="{ top: dialogTop + 'px', left: dialogLeft + 'px' }" @click="hideNotify">
    <div class="dialog-title">
      <span class="label">请输入运单号</span>
      <span class="dialog-info">如需下单<a href="//order.sto.cn/" data-spm="2263463" data-spm-protocol="i" target="_blank">请点击这里</a></span>
    </div>
    <div class="dialog-body" data-spm="2260480">
      <div class="error" v-show="errorShow">
        <i class="tip-triangle"></i>
        <i class="icon error-icon"> </i>
        <span>{{errorMessage}}</span>
      </div>
      <input title="" type="text" name="orderId" v-model="orderId" class="order-input" :class="errorClass">
      <span class="btn" v-show="isChecked" @click="checkOrder" data-spm-click="gostr=/tulong;locaid=6050">查询</span>
      <span class="check-info" v-show="isOk">
        <i class="icon c-icon-ok"></i>
        <i class="info">申通单号</i>
      </span>
      <!--人机验证-->
      <br>
      <div id="_umfp" style="display:inline;width:1px;height:1px;overflow:hidden"></div>
      <div id="dom_id" class="nc-container" v-show="isOk"></div>
    </div>
    <!--<div class="dialog-close close-icon icon" v-on:click="closeDialog"></div>-->
  </div>
  <div class="mask" v-show="show" @click="hideNotify"></div>
</template>

<script>
  import configUtil from '../assets/js/configUtil'

  export default {
    data() {
      return{
        show: true,
        errorShow: false,
        isLogin: false,
        orderId : '',
        isOk: false,
        isChecked: true,
        isCheck : {},
        dialogLeft: 0,
        dialogTop: 0,
        companyCode: '',
        mailNo: '',
        errorMessage: '',
        errorClass: '',
        entryType: '',
        mtopPrefix: configUtil.getMtopPrefix(), // mtop的前缀
        mtopSubDomain: configUtil.getMtopSubDomain(), // mtop的子域
        mtopMainDomain: configUtil.getMtopMainDomain() // mtop的主域
      }
    },
    methods: {
      // 校验订单号
      checkOrder() {
        var me = this;
        me.companyCode = me.getUrlParam("companyCode") || "STO";
        me.mailNo = me.orderId.trim();
        if (me.mailNo) {
          // 申通单号校验
          var promise = lib.mtop.request({
            api: 'mtop.cainiao.delibird.portal.checkmailno',
            v: '1.0',
            data: {"companyCode": me.companyCode, "mailNo": me.mailNo},
            appkey: '4272',
            ecode: 1,
            type: 'GET',
            dataType: 'jsonp',
            timeout: 20000
          });
          promise.then(function(resJson) {
            if(resJson.data.data=="true") {
              // 是申通单号
              // 路由校验
              var router = lib.mtop.request({
                api: 'mtop.cainiao.delibird.router.preroute',
                v: '1.0',
                data: {"cpCode": me.companyCode, "mailNo": me.mailNo, "from": "PC"},
                appkey: '4272',
                ecode: 1,
                type: 'GET',
                dataType: 'jsonp',
                timeout: 20000
              });
              router.then(function(resJson){
                var data = resJson.data;
                if(data.actionSuccess=="true"){
                  // 路由校验成功
                  me.checkSuccess();
                  me.entryType = data.data;
                }
                else{
                  // 路由校验失败
                  me.checkError(data.errorMsg);
                }
              }, function(){
                // 接口请求失败
                me.checkError('网络连接不稳定,请重试');
              });
            }
            else {
              // 不是申通单号
              me.checkError('请输入正确的申通快递运单号');
            }
          }, function () {
            // 接口请求失败
            me.checkError('网络连接不稳定,请重试');
          });
        }
      },
      checkSuccess() {
        var me = this;
        me.isChecked = false;
        me.isOk = true;
        me.isLogin = true;
        me.errorShow = false;
        me.errorMessage = '';
      },
      checkError(msg) {
        var me = this;
        me.isChecked = true;
        me.isOk = false;
        me.errorShow = true;
        me.errorMessage = msg;
      },
      closeDialog() {
        this.show = false;
      },
      // 获取 URL 中的参数
      getUrlParam(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        var r = decodeURIComponent(window.location.search.substr(1)).match(reg);
        if (r != null) {
          return unescape(r[2]);
        }
        else {
          return '';
        }
      },
      // 隐藏警告框
      hideNotify() {
        this.errorShow = false;
      }
    },
    ready() {
      var me = this;
      me.dialogLeft = window.innerWidth / 2 - 150;
      me.dialogTop = window.innerHeight / 2 - 60;
      var token = 'OMTT:' + new Date().getTime() +":"+ (Math.random()*100|0).toString();
      var nc = new noCaptcha({
        renderTo: '#dom_id',
        appkey: 'OMTT',
        scene: 'register',
        token:token,
        callback: function(data) {

          var sendData = {
            csessionid: data.csessionid,
            sig: data.sig,
            appKey: 'OMTT',
            token: token,
            ip: '192.168.1.142'
          };

          me.$http
//          .jsonp('http://webim.daily.taobao.net/visitor/visitorGenerator.do',{
            .jsonp('http://webim.taobao.com/visitor/visitorGenerator.do',{
              params: sendData
            })
            .then((res) => {return res.json();})
            .then((o) => {
              me.isCheck.userName = o.data.userName;
              me.isCheck.userId = o.data.userId;
              me.isCheck.xcode = o.data.xcode;
              me.$dispatch('init-IM', me.companyCode, me.mailNo);
              me.$dispatch('init-check', me.isCheck, me.entryType);
              me.show = false;
            });
        }
      });

      nc.upLang('cn', {
        _startTEXT: "向右滑动进入客服",
        _yesTEXT: "<b>验证通过</b>",
        _Loading: "正在加载..."
      });
    }
  }
</script>

<style lang="less" scoped>
  @import "../assets/base";

  .dialog {
    z-index: 2000;
    width: 300px;
    box-shadow: 0 8px 16px 0 rgba(0,0,0,.3);
    border-radius: 4px;
    background: #fff;
    position: absolute;
    left: 560px;
    top: 300px;

    .dialog-title {
      padding: 26px 20px 0 20px;
      font-size: 14px;
      height: 16px;

      .required {
        color: @red;
        font-size: 16px;
      }

      .dialog-info {
        float: right;
        color: @tintGray;
        font-size: 12px;
        padding-top: 2px;
      }
    }

    .dialog-body {
      padding: 20px;
      font-size: 14px;

      .check-info {

        .icon {
          font-size: 16px;
          width: 16px;
          height: 16px;
          margin-left: 5px;
          color: @green;
        }

        .c-icon-ok:before {
          content: '\f211';
        }

        .info {
          font-size: 12px;
          line-height: 16px;
          position: absolute;
          margin-top: 2px;
          color: @gray;
        }
      }

      label {
        display: block;
        margin-bottom: 10px;
      }

      .error {
        color: @red2;
        padding: 6px;
        line-height: 16px;
        font-size: 12px;
        border: 1px solid @red2;
        margin-bottom: 6px;
        background-color: @red3;
        border-radius: 4px;
        position: absolute;
        bottom: 64px;
        width: 246px;

        .error-icon:before {
          font-size: 13px;
          content: '\f214';
        }

        .close-icon:before {
          float: right;
          content: '\f212';
          font-size: 16px;
          color: #222;
          cursor: pointer;
        }
      }
    }
    .dialog-close {
      position: absolute;
      cursor: pointer;
      top: 10px;
      right: 10px;
    }
    .close-icon:before {
      content: '\f212';
      font-size: 16px;
    }
  }

  .mask {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    overflow: hidden;
    z-index: 1000;
    background-color: #000;
    outline: 0;
    opacity: .5;
    filter: alpha(opacity=50);
    color: black;
  }

  .order-input {
    width: 182px;
  }

  .tip-triangle {
    position: absolute;
    width: 0;
    height: 0;
    bottom: -6px;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid #FF5555;
  }

  .errorOrder {
    border: 1px solid @red2;
  }
</style>



// WEBPACK FOOTER //
// CheckDialog.vue?4d976687